/**
 * Which build you're looking at.
 *
 * The game runs as two copies at once: STABLE, the one that's playtested, and
 * BETA, the one being worked on. They're served from separate checkouts on
 * separate ports, so the only way to tell them apart on screen is to say so —
 * and a bug report that doesn't name its build is a bug report you can't act on.
 *
 * The values are injected at serve/build time by `vite.config.ts` from the
 * CHAGAT_CHANNEL env var and `git rev-parse`.
 */

declare const __BUILD_CHANNEL__: string;
declare const __BUILD_COMMIT__: string;

export type BuildChannel = 'stable' | 'beta' | 'dev';

export const BUILD_CHANNEL: BuildChannel =
  (__BUILD_CHANNEL__ as BuildChannel) ?? 'dev';

/** Short commit; a trailing '+' means there are uncommitted edits on top. */
export const BUILD_COMMIT: string = __BUILD_COMMIT__ ?? 'unknown';

/** "BETA · d414934" — what goes in the corner and on the title screen. */
export function buildLabel(): string {
  return `${BUILD_CHANNEL.toUpperCase()} · ${BUILD_COMMIT}`;
}

/** Channel colour: stable reads calm, beta reads "this one is moving". */
export function buildColor(): string {
  return BUILD_CHANNEL === 'stable' ? '#66d9a0'
    : BUILD_CHANNEL === 'beta' ? '#ffd23f'
      : '#7f97ae';
}
